module.exports = __webpack_public_path__ + "img/adlightech_logo.99eba1d8.png";